module.exports = __webpack_public_path__ + "img/factory-2.9482ed16.jpg";